const config = {
  restUrl: process.env.REACT_APP_restUrl,
  mode: process.env.NODE_ENV,
};

export default config;
